import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BeatLoader } from 'react-spinners';
import {
  faUsers,
  faUserTie,
  faHistory,
  faCalendarAlt,
} from '@fortawesome/free-solid-svg-icons';

import { fetchBoardData } from '../../utils/fetchBoardData';

import { BoardData } from './boardTypes';
import './BoardMembers.css';

const DRIVE_FILE_ID = '1HBYl35J3f6KULatd6qKdEVA9xXguTkDP';

const BoardMembers = () => {
  const [boardData, setBoardData] = useState<BoardData | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadBoardData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchBoardData(DRIVE_FILE_ID);
        setBoardData(data);
      } catch (error) {
        console.error('Failed to load board data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadBoardData();
  }, []);

  if (isLoading) {
    return (
      <div className="board-members-container">
        <div className="text-center my-5">
          <BeatLoader color="#0d6efd" size={15} margin={2} />
        </div>
      </div>
    );
  }

  const { currentTenureBoardMembers, formerExecutiveMembers } = boardData;

  return (
    <div className="board-members-container">
      {/* Current Board Members Section */}
      <div className="board-card">
        <div className="d-flex align-items-center mb-4">
          <FontAwesomeIcon icon={faUserTie} className="board-icon me-2" />
          <div>
            <h3 className="mb-0">Current Executive Committee</h3>
            <div className="tenure-badge mt-2">
              <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
              Tenure: 2025-27
            </div>
          </div>
        </div>

        <div className="table-responsive">
          <table className="board-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              {currentTenureBoardMembers.map((member, index) => (
                <tr
                  key={index}
                  className={index < 2 ? 'table-highlight' : undefined}
                >
                  <td>{member.name}</td>
                  <td>{member.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Former Executive Committee Members Section */}
      <div className="board-card mt-4">
        <div className="d-flex align-items-center mb-4">
          <FontAwesomeIcon icon={faHistory} className="board-icon me-2" />
          <h3 className="mb-0">Former Executive Committee Members</h3>
        </div>

        <div className="accordion" id="formerECAccordion">
          {formerExecutiveMembers.map((tenure, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  <FontAwesomeIcon icon={faUsers} className="me-2" />
                  EC ({tenure.tenure})
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading${index}`}
                data-bs-parent="#formerECAccordion"
              >
                <div className="accordion-body">
                  <div className="table-responsive">
                    <table className="board-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Position</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tenure.members.map((member, mIndex) => (
                          <tr key={mIndex}>
                            <td>{member.name}</td>
                            <td>{member.position}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BoardMembers;
